// extracted by mini-css-extract-plugin
export default {"howCard":"HowCard_howCard__VWuU2"};